/**
 * Действия редактора, рождённые вне createSlice фасада (WEB-2552, пачка 49,
 * заход Р2 рефакторинга editorSlice.ts). Санки сохранения и публикации
 * зовут `setTierLimitReason`, а фасад слушает эти санки в extraReducers:
 * пока действие рождал createSlice фасада, вынос санков давал круговой
 * импорт. Отдельный createAction развязывает круг — санки берут действие
 * отсюда, фасад ловит его в extraReducers через builder.addCase и
 * реэкспортирует под прежним именем. Строковое имя прежнее байт в байт
 * (`editor/setTierLimitReason`, закреплено тестом-соседом): его слушает
 * перечень служебных действий EDITOR_SERVICE_ACTION_NAMES.
 */
import { createAction } from "@reduxjs/toolkit";

/**
 * WEB-1908 (возврат приёмки В11-Л6): причина последнего тарифного отказа.
 * Пишется на КАЖДОМ отказе 402 по тарифу, включая `null` (отказ без
 * причины), — иначе окно тарифа показало бы причину прошлого раза.
 */
export const setTierLimitReason = createAction<
  string | null,
  "editor/setTierLimitReason"
>("editor/setTierLimitReason");

/**
 * WEB-2704: «Дублировать экран» — копия встаёт сразу за исходным, имя =
 * имя исходного + суффикс на языке кабинета (его подставляет панель).
 * «Дублировать блок» — копия на том же экране сразу под исходным. Тела —
 * `./duplicateState.ts`, фасад ловит их в extraReducers через
 * withHistoryPayload (одно нажатие = один шаг «Отменить»). Отдельный
 * createAction, а не редьюсер createSlice, — чтобы фасад не рос (храповик
 * длины WEB-2552). Ручная правка, не служебное действие.
 */
export const duplicateScreen = createAction<
  { screenId: string; nameSuffix: string },
  "editor/duplicateScreen"
>("editor/duplicateScreen");

export const duplicateBlock = createAction<
  { screenId: string; blockId: string },
  "editor/duplicateBlock"
>("editor/duplicateBlock");
